var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolTip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-help-circle",
    "data-name": "Icon ionic-md-help-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.113,
    height: 19.75,
    viewBox: "0 0 19.113 19.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-help-circle-2",
    "data-name": "Icon ionic-md-help-circle",
    d: "M12.931,3.375A9.724,9.724,0,0,0,3.375,13.25a9.724,9.724,0,0,0,9.556,9.875,9.724,9.724,0,0,0,9.556-9.875A9.724,9.724,0,0,0,12.931,3.375ZM13.9,19.184h-1.93V17.191H13.9Zm-.009-2.991H11.976c0-3.181,2.867-2.953,2.867-4.928a1.912,1.912,0,1,0-3.823-.009H9.109a3.824,3.824,0,1,1,7.645,0C16.754,13.73,13.887,14.01,13.887,16.194Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#ee2b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/tool-tip.c8fa666459779db8c19f313533fc3324.svg";
export { ForwardRef as ReactComponent };